import React from 'react'
import './footer-style.css'

const Footer = ({ children }) => (
  <section className="footer">
    {children}
  </section>
)

export default Footer